import {
  fetchJournalEntriesWithSource,
  JournalEntriesWithSourceResult,
} from '../clients/journalEntryApiClient'

export class JournalEntryService {
  async getJournalEntriesWithSource(opts: {
    entryId?: string
    fiscalYearId?: string
    sourceType?: string
    series?: string
    page?: number
    pageSize?: number
  }): Promise<JournalEntriesWithSourceResult> {
    return fetchJournalEntriesWithSource(opts)
  }
}

export const journalEntryService = new JournalEntryService()
